<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content"></div>
    <img class="page-logo" src="@/assets/home/11.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>周公解梦</span>
    </div>

    <div class="search-box">
      <input type="text" v-model="keyword" placeholder="请输入梦境关键词" />
      <div class="search-btn" @click="search">开始解梦</div>
    </div>
    <div class="common-title">常见的梦</div>
    <div class="common">
      <div v-for="(item,index) in list" :key="index" @click="keyword = item">{{item}}</div>
    </div>

    <!-- <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div> -->
    <shareBottomComp v-if="share == 1"></shareBottomComp>

  </div>
</template>

<script>
/**
@description:周公解梦
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";

import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: {shareBottomComp,topTab},
  data() {
    return {
      keyword:"",
      list:[],
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'周公解梦',
        path:'/zgjm'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
     if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('zgjm','周公解梦','','',HERF+'/image/11.png')
    this.oneiromancyList();
  },
  methods: {
    search() {
      // this.api.oneiromancy({keyword:this.keyword}).then((res) => {
      //   console.log(res);
      // });
      if (this.keyword === "") return this.Toast("请輸入关键字");

      this.$router.push({path:"zgjmsearch",query: { keyword: this.keyword }});
    },
    oneiromancyList(){
      this.api.oneiromancyCommon().then(res=>{
        this.list = res.data;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}

.search-box {
  margin-top: 0.48rem;
  height: 1rem;
  background: #f0f0f0;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0 0.04rem;
  input {
    flex: 1;
    padding-left: 0.76rem;
    height: 100%;
    border: none;
    background: transparent;
  }
  .search-btn {
    width: 2.12rem;
    height: 0.88rem;
    border-radius: 0.44rem;
    background: #4fd9d5;
    font-size: 0.3rem;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.common-title {
  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin-top: 1.3rem;
  margin-bottom: 0.36rem;
}
.common {
  width: 5rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  > div {
    padding: 0 0.3rem;
    height: 0.62rem;
    border: 1px solid #4fd9d5;
    border-radius: 0.6rem;
    background: #edfbfb;
    font-size: 0.3rem;
    color: #4fd9d5;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.22rem 0.08rem;
  }
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>

